import { LANGUAGES } from "App.constants";
import { LangType } from "App.types";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import styles from "./ChangeLanguageModel.module.scss";
import dayjs from "dayjs";

const ChangeLanguageModal = () => {
  const navigate = useNavigate();

  const setLanguage = (lang: LangType) => {
    Cookies.set("lang", lang.short, { expires: dayjs().add(1, "year").toDate() });
    navigate("/courses");
    window.location.reload();
  };

  return (
    <div className={styles.changeLanguageModel}>
      {LANGUAGES.map((lang) => (
        <div key={lang.value} className={styles.item} onClick={() => setLanguage(lang as LangType)}>
          <div className={styles.icon}>{lang.icon}</div>
          <div className={styles.title}>{lang.title}</div>
        </div>
      ))}
    </div>
  );
};

export default ChangeLanguageModal;
